import cx from "classnames";
import { get } from "lodash";
import React from "react";
import { connect } from "react-redux";
import PKHBtn from "~/components/common/atoms/Button";
import {
  addScheduleRepayment,
  checkRepayment
} from "~/store/totalData/actions";
import styles from "./style.module.scss";

const BottomNavigationNews = props => {
  const { onCancel, IsAuthenticated, bookingInfo } = props;

  const statusBooking = get(bookingInfo, "status");

  const cancelBookingButton = (
    <PKHBtn
      flat
      className={cx(styles.button, styles.cancel)}
      onClick={onCancel}
    >
      <div className={styles.text}>
        <i className="fal fa-times" /> Hủy phiếu
      </div>
    </PKHBtn>
  );

  const renderButton = () => {
    if (statusBooking === 1) {
      if (IsAuthenticated) return cancelBookingButton;
    }
  };

  return (
    <React.Fragment>
      <div className={styles.bottom_navigation}>{renderButton()}</div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated }
  } = state;

  return {
    IsAuthenticated
  };
};

export default connect(mapStateToProps, {
  checkRepayment,
  addScheduleRepayment
})(BottomNavigationNews);
